
import { initializeApp } from "firebase/app"
import {getFirestore} from "firebase/firestore"
const firebaseConfig = {
  apiKey: "AIzaSyAlyoo_c2q6N7tTB1nUYfEJUv-NDECpFTs",
  authDomain: "react-recipe-app-f9a53.firebaseapp.com",
  projectId: "react-recipe-app-f9a53",
  storageBucket: "react-recipe-app-f9a53.appspot.com",
  messagingSenderId: "253630787511",
  appId: "1:253630787511:web:093d269a3d49ba78004232"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);

export {db}